import type { AvatarState } from '../../types/voice';

interface AvatarStateIndicatorProps {
  state: AvatarState;
  size?: 'sm' | 'md' | 'lg';
}

const stateConfig: Record<AvatarState, { color: string; label: string; pulse: boolean }> = {
  idle: { color: 'bg-slate-400', label: 'Listo', pulse: false },
  listening: { color: 'bg-primary', label: 'Escuchando', pulse: true },
  thinking: { color: 'bg-secondary', label: 'Pensando', pulse: true },
  speaking: { color: 'bg-accent', label: 'Hablando', pulse: false },
  error: { color: 'bg-error', label: 'Error', pulse: true },
};

export default function AvatarStateIndicator({ state, size = 'md' }: AvatarStateIndicatorProps) {
  const config = stateConfig[state];
  
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  return (
    <div className="flex items-center gap-2">
      <div
        className={`${sizeClasses[size]} ${config.color} rounded-full ${
          config.pulse ? 'animate-pulse' : ''
        }`}
      />
      <span className="text-sm font-medium text-base-content/80">
        {config.label}
      </span>
    </div>
  );
}